export default {"src":"/_next/static/media/signup_icon_2.9c6e2927.svg","height":32,"width":26};